module.exports = __webpack_public_path__ + "static/media/dekton-white.65d3b550.svg";